import type { ColorParam, Generation, ImageModelId, LandscapingConfig } from '@paint-ai/shared';
import { createContext, useContext } from 'react';
import type { ColorSlot, StudioState } from './studio-reducer';

export interface StudioContextValue {
  state: StudioState;
  selectImage: (image: string) => void;
  setColor: (slot: ColorSlot, color: ColorParam) => void;
  setMasterPrompt: (masterPrompt: string) => void;
  setModel: (model: ImageModelId) => void;
  setLandscaping: (landscaping: LandscapingConfig) => void;
  /** Restores a past generation (photo, colours, prompt, render) into the studio. */
  loadGeneration: (generation: Generation) => void;
  reset: () => void;
  generate: () => void;
  isGenerating: boolean;
  generationStatus: string | null;
  generationError: string | null;
}

export const StudioContext = createContext<StudioContextValue | null>(null);

export function useStudio(): StudioContextValue {
  const context = useContext(StudioContext);
  if (!context) throw new Error('useStudio must be used inside <StudioProvider>');
  return context;
}
